var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOpenapiReserve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#F8B407"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.308 13.3276C12.158 12.8532 14.333 10.3336 14.333 7.29654C14.333 3.92133 11.6467 1.18518 8.33301 1.18518C5.0193 1.18518 2.33301 3.92133 2.33301 7.29654C2.33301 10.4011 4.60577 12.965 7.54905 13.3562L8.4201 14.8338L9.308 13.3276Z",
    fill: "#FDFFFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2924_6255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81771 5.19794V6.43348C5.39944 6.48605 5.0699 6.27575 5.01921 5.94715V5.19794C4.98118 4.79048 5.61491 3.92297 6.26132 3.92297H10.3552C10.8242 3.92297 11.5466 4.51445 11.5846 5.19794V5.94715C11.572 6.27575 11.2424 6.43348 10.7861 6.43348V5.19794C10.7937 5.05348 10.7594 5.01135 10.6214 5.01393H5.9698C5.84718 5.01437 5.81344 5.05399 5.81771 5.19794Z",
    fill: "#F8B407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55078 5.06653C4.66215 4.96556 4.72862 4.96114 4.85497 5.06653V5.90774C4.74122 5.97792 4.67462 5.97983 4.55078 5.90774V5.06653Z",
    fill: "#F8B407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7246 5.06653C11.836 4.96556 11.9024 4.96114 12.0288 5.06653V5.90774C11.915 5.97792 11.8484 5.97983 11.7246 5.90774V5.06653Z",
    fill: "#F8B407"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1084 8.01178C5.1084 7.4595 5.55611 7.01178 6.1084 7.01178H10.471C11.0233 7.01178 11.471 7.4595 11.471 8.01178V9.27149C11.471 9.75951 11.1215 10.1659 10.659 10.2538C10.6596 10.2641 10.6598 10.2744 10.6598 10.2847C10.6598 10.6114 10.4044 10.8762 10.0895 10.8762C9.77445 10.8762 9.5191 10.6114 9.5191 10.2847C9.5191 10.2803 9.51914 10.2759 9.51924 10.2715H7.0602L7.06034 10.2847C7.06034 10.6114 6.80498 10.8762 6.48998 10.8762C6.17498 10.8762 5.91963 10.6114 5.91963 10.2847C5.91963 10.2744 5.91988 10.2641 5.92039 10.2538C5.45798 10.1659 5.1084 9.75951 5.1084 9.27149V8.01178Z",
    fill: "#F8B407"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.47754,
    y: 4.22534,
    width: 3.59958,
    height: 0.6572,
    rx: 0.3286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.47777,
    cy: 8.56278,
    rx: 0.456285,
    ry: 0.473184,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0774,
    cy: 8.56278,
    rx: 0.456285,
    ry: 0.473184,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2924_6255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.57143,
    height: 7.11111,
    fill: "white",
    transform: "translate(4.04688 3.85187)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpenapiReserve);
export default __webpack_public_path__ + "static/media/ic-openapi-reserve.f5c2f900a5e60f0f3f8bea5bb3e25680.svg";
export { ForwardRef as ReactComponent };